export const FETCH_RESTORE_ROLES_BY_ID_REQUEST = 'FETCH_RESTORE_ROLES_BY_ID_REQUEST'
export const FETCH_RESTORE_ROLES_BY_ID_SUCCESS = 'FETCH_RESTORE_ROLES_BY_ID_SUCCESS'
export const FETCH_RESTORE_ROLES_BY_ID_FALUIRE = 'FETCH_RESTORE_ROLES_BY_ID_FALUIRE'

